import type { ModifyBidSellerFee } from './modify-bid-seller-fees.model';

export function generateModifyBidSellerFeesObject({
  bidId,
  newAmount,
  sellerFee = 0,
}: GenerateModifyBidSellerFeesOptions): ModifyBidSellerFee {
  return {
    id: `${bidId}-${sellerFee}`, // See modify-bid-seller-fees.transformers.ts
    bidId,
    newAmount,
    sellerFee,
  };
}

export interface GenerateModifyBidSellerFeesOptions {
  readonly bidId: number;
  readonly newAmount: number;
  readonly sellerFee: number;
}
